import React, { useState, useEffect, useContext } from "react";
import { useRouteMatch } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { apiGet } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { makeStyles } from '@mui/styles';
import { Redirect } from "react-router-dom";
import LoaderAnimation from "pages/LoaderAnimation";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { spacing } from '@mui/system';
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: spacing(1),
        minWidth: 320,
    },
    selectEmpty: {
        marginTop: spacing(2),
    },
}));

export default function CompanyModal (props) {
    let { path, url } = useRouteMatch();
    const { setCompany } = useContext(PrivateRoutesContext);
    const classes = useStyles();
    const [companies, setCompanies] = useState(null);

    const [selectCompany, setSelectCompany] = useState("");
    const [hasError, setHasError] = useState(false);

    const handleChange = (event) => {
        setSelectCompany(event.target.value);
    };

    const handleClose = () => {
        if (localStorage.getItem("selectedCompanyId")) {
            props.closeModal(false);
            localStorage.setItem(`CompanyDropdown`, `checkOpen`);
        }
    };

    const handleSubmit = () => {
        submitCompany(selectCompany)
    }

    const submitCompany = (company) => {
        setSelectCompany("");
        if (company) {
            if(path.includes("/ap3") || path.includes("/cui")) {
                localStorage.setItem(`selectedParentCompanyId`, company)
            }
            else if(path.includes("/broker") ) {
                localStorage.setItem(`selectedBrokerCompanyId`, company)
            }
            else{
                localStorage.setItem(`selectedCompanyId`, company)
            }
            setCompany(company)
            setSelectCompany(company);
            props.closeModal(false)
        }
    };

    const Logout = () => {
      window.location.href = '/logout';
    }

    useEffect(() => {
        console.log("open");
        setHasError(false);
        if (props.open) {
            apiGet(apiUrls.getCompanyList).then((response) => {
                let companyList = response.data;
                let companyId = localStorage.getItem("selectedCompanyId");
                console.log(companyList);
                if(path.includes("/ap3") || path.includes("/cui") ){
                    companyList = companyList.filter(c => c.companyType == 'AP3');
                    // companyId = localStorage.getItem("selectedParentCompanyId");
                }
                else if(path.includes("/broker") ) {
                    companyList = companyList.filter(c => c.companyType == 'Broker');
                }
                else{
                    companyList = companyList.filter(c => (c.companyType != 'AP3' && c.companyType != 'Broker' ));
                }
                setCompanies(companyList);
                if (companyList.length > 0) {
                    if (companyList.length === 1) {
                        submitCompany(companyList[0].companyId);
                    } 
                    else {
                        const foundIndex = companyList.findIndex(
                            (item) => item.companyId === companyId
                        );

                        if (foundIndex > -1) {
                            setSelectCompany(companyList[foundIndex].companyId);
                        }
                    }
                } else {
                    setSelectCompany("");
                }
            })
            .catch(response => {
                  setHasError(true);
              }
            );
        }
    }, [props.open]);

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Select Company"}</DialogTitle>
                <DialogContent sx={{minWidth:'350px'}}>
                    {companies == null ? <LoaderAnimation /> :
                        companies.length === 0 ? <div>No companies available</div> :
                            <FormControl className={classes.formControl}>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectCompany}
                                    onChange={handleChange}
                                    placeholder="Select Company"
                                    variant="standard"
                                >
                                    {companies.map((item, i) => (
                                        <MenuItem key={i} value={item.companyId}>
                                            {item.companyName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>}
                </DialogContent>

                <DialogActions>
                    <Button variant="outlined" onClick={handleSubmit} color="primary" disabled={!selectCompany}>
                        Submit
                    </Button>
                    {(companies !== null && companies.length === 0) || hasError ?
                        <Button variant="outlined" onClick={Logout} color="primary">
                            Logout
                        </Button> : null
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
}
